var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-row"},[_c('Avatar',{attrs:{"user":_vm.shareWith,"display-name":_vm.computedDisplayName,"is-no-user":_vm.isNoUser}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }